import React from "react";
import { ErrorMessage, Field, Formik } from "formik";
import { Input } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().required("Nama file tidak boleh kosong!")
});

export default function LibraryUploadFileForm({ onSubmit, defaultValues }) {
  return (
    <Formik
      initialValues={defaultValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ setFieldValue, handleSubmit, values }) => (
        <>
          <div className="form-group row">
            <div className="col">
              <Field
                name="name"
                label="Nama file"
                component={Input}
                placeholder="Masukkan nama file"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col d-flex flex-column">
              <label htmlFor="file">Dokumen</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    name="file"
                    type="file"
                    className="custom-file-input"
                    // accept=".doc, .docx, .xls, .xlsx, .csv, .pdf"
                    id="project-document"
                    onChange={e => setFieldValue("file", e.target.files[0])}
                  />
                  <label
                    className="custom-file-label"
                    htmlFor="project-document"
                  >
                    {values.file instanceof File
                      ? values.file.name
                      : "Choose file"}
                  </label>
                </div>
              </div>
              <ErrorMessage
                name="file"
                render={msg => <span className="mt-2 text-danger">{msg}</span>}
              />
            </div>
          </div>
          <button
            className="btn btn-primary float-right"
            onClick={handleSubmit}
          >
            Simpan
          </button>
        </>
      )}
    </Formik>
  );
}
